<h1 fxLayoutAlign="center" >Eligibility</h1>
<p fxLayoutAlign="center">for All India Pilot Aptitude Test </p>

<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around" style=" text-align:center;">
	
		<mat-card  fxFlex="25">
			<i class="icon ion-md-school"></i>
			<mat-card-title>
				Education
			</mat-card-title>
			<mat-card-content>
				10+2 and  A minimum score of 55% from a recognized board.
			</mat-card-content>
		</mat-card>

		<mat-card fxFlex="25">
      <i class="icon ion-md-person"></i>
			<mat-card-title>
				Age
			</mat-card-title>
			<mat-card-content>
				16 years on the date of application for All India Pilot Aptitude Test.
			</mat-card-content>
		</mat-card>
	
		<mat-card fxFlex="25">
      <i class="icon ion-md-globe"></i>
			<mat-card-title>
				Nationality
			</mat-card-title>
			<mat-card-content>
				Must be an Indian Citizen.
			</mat-card-content>
		</mat-card>


</div>

<h1 fxLayoutAlign="center" >Selection</h1>

<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around" style=" text-align:center;">

  <div fxLayout="column" fxFlex="25">
   <h3>Round 1</h3>
    <mat-card class="red">
      <mat-card-title > Eligibility</mat-card-title>
      <mat-card-content> 
        <p>Education</p>
        <p>Medical</p>
      </mat-card-content>
    </mat-card>
   <mat-card class="red">
      <mat-card-title> Suitability</mat-card-title>
      <mat-card-content> 
        <p>Personality</p>
        <p>Preference</p>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxLayout="column" fxFlex="25">
  <h3>Round  2</h3>
    <mat-card class="yellow">
      <mat-card-title> Proficiency</mat-card-title>
      <mat-card-content> 
        <p>Language</p>
        <p>Numerical Ability</p>
      </mat-card-content>
    </mat-card>
   <mat-card class="yellow">
      <mat-card-title> Aptitude</mat-card-title>
      <mat-card-content> 
        <p>Short Term Memory</p>
        <p>Hand Eye Coordination</p>
      </mat-card-content>
    </mat-card>
  </div>

  <div fxLayout="column" fxFlex="25">
   <h3>Round 3</h3>
    <mat-card class="green">
      <mat-card-title> Interview</mat-card-title>
      <mat-card-content> 
       <p>Personal Interview</p>
       <p>Critical Thinking</p>
      </mat-card-content>
    </mat-card>
  
  </div>

</div>
